const ANSWER_STEPS = [
  {
    id: "question",
    label: "Your question",
    detail: "The concern sets the Jyotish lens.",
  },
  {
    id: "kundali",
    label: "Kundali calculation",
    detail: "Graha, houses and Lagna come from the engine.",
  },
  {
    id: "dasha",
    label: "Active dasha",
    detail: "The current period explains why it is happening now.",
  },
  {
    id: "upay",
    label: "Answer and upay",
    detail: "The interpretation ends with one practical next step.",
  },
] as const;

export function JyotishAnswerPath({
  title = "From your question to a chart-grounded answer",
  subtitle = "No invented positions. The engine computes the kundali; your AI Jyotishi explains what the calculation means.",
  className = "",
}: {
  title?: string;
  subtitle?: string;
  className?: string;
}) {
  return (
    <section
      className={`jyotish-answer-path ${className}`}
      aria-label="How your Jyotish answer is made"
    >
      <div className="jyotish-answer-path__copy">
        <p className="jyotish-answer-path__eyebrow">How your answer is made</p>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>

      <div className="jyotish-answer-path__visual" aria-hidden>
        <svg viewBox="0 0 260 260" focusable="false">
          <circle className="jyotish-answer-path__glow" cx="130" cy="130" r="118" />
          <circle className="jyotish-answer-path__orbit" cx="130" cy="130" r="96" />
          <circle className="jyotish-answer-path__orbit" cx="130" cy="130" r="72" />
          <rect className="jyotish-answer-path__chart" x="76" y="76" width="108" height="108" />
          <path className="jyotish-answer-path__chart" d="M130 76 184 130 130 184 76 130Z" />
          <path className="jyotish-answer-path__chart" d="M76 76 184 184M184 76 76 184" />
          <circle className="jyotish-answer-path__graha" cx="130" cy="34" r="9" />
          <circle className="jyotish-answer-path__graha" cx="226" cy="130" r="7" />
          <circle className="jyotish-answer-path__graha" cx="130" cy="226" r="8" />
          <circle className="jyotish-answer-path__graha" cx="34" cy="130" r="6" />
          <circle className="jyotish-answer-path__bindu" cx="130" cy="130" r="5" />
        </svg>
        <span className="jyotish-answer-path__visual-label">Your computed kundali</span>
      </div>

      <ol className="jyotish-answer-path__steps">
        {ANSWER_STEPS.map((step, index) => (
          <li key={step.id} data-step={step.id}>
            <span className="jyotish-answer-path__step-number">{index + 1}</span>
            <span>
              <strong>{step.label}</strong>
              <small>{step.detail}</small>
            </span>
          </li>
        ))}
      </ol>

      <div className="jyotish-answer-path__proof" aria-label="Answer provenance">
        <span>Engine computed</span>
        <span>Rule anchored</span>
        <span>Personally explained</span>
      </div>
    </section>
  );
}

export default JyotishAnswerPath;
